/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/
import axios from '../../axios.js'
import router from '../../router.js'
import jwtDecode from 'jwt-decode'
import { reject, resolve } from 'core-js/fn/promise'
const moment = require('moment') // require
const clonedeep = require('lodash.clonedeep')

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  ActionLogin({state, commit, dispatch}, payload){
    console.log(state.selectedClientID)
    return new Promise((resolve, reject) => {
      axios.post('authorization/login', payload)
      .then(response => {
          console.log(state.selectedClientID)
          
          this.commit("prepulse/SetEverythingCleared")
          this.commit("pulse/SetEverythingCleared")
          
          if(response.data.bSuccess){
            console.log(state.selectedClientID)
            var userInfo = response.data.oData;
            console.log("User Info", userInfo)
            if(userInfo != null && userInfo.UserTypeName != null && userInfo.UserTypeName.toLowerCase().trim().indexOf('auditor') != -1){
              router.push("/pre-pulse/my-stuff")
            }else{
              router.push("/pulse/my-stuff")
            }
          }
          resolve(response)
      })
      .catch(error => {
        // dispatch("ActionCheckError", error)
        reject(error)
      })
        
    })
  },

  ActionLoginOKTA({state, commit, dispatch}, payload){
    console.log("LOGIN OKTA")
    this.commit("prepulse/SetEverythingCleared")
    this.commit("pulse/SetEverythingCleared")
    
    if(payload.APIKey != null && payload.APIKey != ''){
      console.log(state.selectedClientID)
      var userInfo = payload;
      console.log("User Info", userInfo)
      if(userInfo != null && userInfo.UserTypeName != null && userInfo.UserTypeName.toLowerCase().trim().indexOf('auditor') != -1){
        router.push("/pre-pulse/my-stuff")
      }else{
        router.push("/pulse/my-stuff")
      }
    }
  },
  
  ActionVerifyToken({state, commit, dispatch}, payload){
    var tkn = $cookies.get("tkn")
    console.log($cookies.keys())
    //token doesn't exist - bounce to login
    var loggedOutToken = localStorage.getItem("loggedOutToken")
    console.log("Logged Out Token: " + loggedOutToken)
    if(tkn == null){
      console.log("No token!")
      this.dispatch("ActionLogOut")
      return
    }
    
    
    var tknData = jwtDecode(tkn)
    
    if(tknData.exp == loggedOutToken){
      this.dispatch("ActionLogOut")
      return
    }
    
    
    console.log(tknData)
    
    var expiration = tknData.exp
    console.log("EXPERATION: ", expiration)
    var t = moment.unix(expiration).toDate() - (new Date()).getTime()
    console.log(t / 1000 / 60 + " minutes remaining")

    dispatch("ActionGetUserInfo").then(x => {
      commit("SetIsAuthorized", true)
    }).catch(err => {
      commit("SetIsAuthorized", false)
    })

    //Set Session ending soon
    setTimeout(function(){
      console.log("Session expired")
      commit("SetSessionEndingSoon", true)
    }, t - 1000 * 60 * 5)


    //Bounce to login when cookie expires
    setTimeout(function(){
      var tkn = $cookies.get("tkn")
      var tknData = jwtDecode(tkn)
      var expiration = tknData.exp
      console.log("EXPIRATION: ", expiration)
      var t = moment.unix(expiration).toDate() - (new Date()).getTime()
      var minsRemaining = t / 1000 / 60;
      console.log("MINS REMAINING:", minsRemaining)

      if(state.fileUploading == true){
        // REFRESH TOKEN
        axios.post('authorization/refresh')
          .then(response => {
            console.log("Refresh token response ", response.data)
            if(response.data.bSuccess == true){
              commit("SetSessionEndingSoon", false)
              dispatch("ActionVerifyToken")
              // resolve(response)
            }else{
              // reject(response)
            }
          }).catch((error) => {
            console.log("Refresh Token Error: "+error)
            $cookies.remove("tkn") //Not doing anything
    
            commit("SetIsAuthorized", false)
            router.push("/login")
          })
  
      }else if(minsRemaining < 1){
        console.log("Session expired")
        dispatch("ActionLogOut")
      }
    }, t + 1000)

  },

  ActionLogOut({state, commit, dispatch}){
    
    // if(state.fileUploading == true){
    //   // REFRESH TOKEN
    //   axios.post('authorization/refresh')
    //     .then(response => {
    //       console.log("Refresh token response ", response.data)
    //       if(response.data.bSuccess == true){
    //         commit("SetSessionEndingSoon", false)
    //         dispatch("ActionVerifyToken")
    //         // resolve(response)
    //       }else{
    //         // reject(response)
    //       }
    //     }).catch((error) => {
    //       console.log("Refresh Token Error: "+error)
    //       $cookies.remove("tkn") //Not doing anything
  
    //       commit("SetIsAuthorized", false)
    //       router.push("/login")
    //     })

    // }else{
      const token = $cookies.get("tkn")
      var decoded = token ? jwtDecode(token) : { exp: new Date() }
      localStorage.setItem("loggedOutToken", decoded.exp)
      this.commit("prepulse/SetEverythingCleared")
      this.commit("pulse/SetEverythingCleared")
  
      axios.post('authorization/logout')
        .then(response => {
          $cookies.remove("tkn") //Not doing anything
  
          commit("SetIsAuthorized", false)
          router.push("/login")
          console.log("Log out response ", response.data)
        }).catch((error) => {
          $cookies.remove("tkn") //Not doing anything
  
          commit("SetIsAuthorized", false)
          router.push("/login")
          console.log("Log out response ", response.data)
        })
    // }
  },

  ActionRefreshToken({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      // REFRESH TOKEN
      axios.post('authorization/refresh')
      .then(response => {
        console.log("Refresh token response ", response.data)
        if(response.data.bSuccess == true){
          commit("SetSessionEndingSoon", false)
          dispatch("ActionVerifyToken")
          resolve(response)
        }else{
          reject(response)
        }
      }).catch((error) => {
        console.log("Refresh token error: "+error)
        $cookies.remove("tkn") //Not doing anything

        commit("SetIsAuthorized", false)
        router.push("/login")
      })
    })
  },

  ActionSetClient({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.post('account/setclient?id=' + payload)
        .then(response => {
          console.log("Set Client response ", response.data)
          commit("SetClientID", response.data.oData.ClientID)
          commit("SetClientSet", true)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error)
          reject(error)
        })
    })
  },

  ActionGetUserInfo({state, commit, dispatch}){
    return new Promise((resolve, reject) => {
      axios.get('account/userinfo')
        .then(response => {
          if(response.data.bSuccess){
            var userInfo = response.data.oData;
            console.log("User Info", userInfo)
            commit("SetUserInfo", userInfo)
            resolve(userInfo)
          }
        })
        .catch(error => {
          dispatch("ActionCheckError", error)
          console.log(error)
          reject(error)
        })
    })
  },

  ActionGetSecurityRights({state, commit, dispatch}){
    return new Promise((resolve, reject) => {
      axios.get('security/SecRights')
        .then(response => {
          console.log("Security rights response ", response.data)
         
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error)
          reject(error)
        })
    })
  },

  ActionGetLookup({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.get('lookup')
        .then(response => {
          console.log("get lookups")
          commit("SetLookup", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error)
          reject(error)
        })
    })
  },

  ActionSetFileUploading({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit("SetFileUploading", payload)
      resolve(payload)
    })
  },

  ActionCheckError ({context, dispatch}, error) {
    console.log('ACTION ERROR', error)
    if (error.response == null) {
      console.log('ERROR RESPONSE NULL')
      dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error', 'body':['Connection to server timed out, or uncaught error.'], 'details':"", 'callback':''}, {root:true}) 
      dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
    } else {
      switch (error.response.status) {
      case 400:
        console.log('ERROR 400')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error Code 400', 'body':['Bad Request. Contact IT.'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        break
      case 401:
        console.log('ERROR 401')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error Code 401', 'body':['Your session has expired. Please login again.'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        dispatch('ActionLogOut')
        break
      case 403:
        console.log('ERROR 403')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error Code 403', 'body':['Forbidden Access, you do not have permission.'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        break
      case 404:
        console.log('ERROR 404')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error Code 404', 'body':['Can not find the server.'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        break
      case 408:
        console.log('ERROR 408')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error Code 408', 'body':['Connection to server timed out'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        break
      case 500:
        console.log('ERROR 500')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error Code 500', 'body':['Internal Server Error. Contact IT.'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        break
      default:
        console.log('ERROR DEFAULT')
        dispatch('ActionSetModalData', {'modal':'AlertModal', 'header':'Error', 'body':['Connection to server timed out, or uncaught error'], 'details':error.response.data.sMessage || "", 'callback':''}, {root:true}) 
        dispatch('ActionOpenCloseModal', {'modal':'AlertModal', 'show':true}, {root:true})
        break
      }  
    }   
  },

  ActionSetModalData ({commit}, payload) {
    commit('SetModalData', payload)
  },

  ActionOpenCloseModal ({commit}, payload, payload2) {
    commit('SetOpenCloseModal', payload)
  }
}

export default actions
